import * as React from "react";

import {
    Modal,
    Form,
    FormGroup,
    Label,
    Input,
    ModalFooter,
    Button,
    ModalBody,
    ModalHeader,
    Row,
    Col
} from "reactstrap";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import i18n from "../i18n";
import { getAsync } from "utils/net";
import { Channels } from "utils/channels";

export interface ScenarioEditProps {
    item: any;
    isOpen: boolean;
    isNew: boolean;
    typeValues: any[];
    marketValues: any[];
    scenarioList: any[];
    onSave: (model: any) => void;
    onCancel: () => void;
}
export interface ScenarioEditState {
    item: any;
    intents: any[];
    entities: any[];
}

export default class ScenarioEdit extends React.Component<
    ScenarioEditProps,
    ScenarioEditState
> {
    constructor(props: ScenarioEditProps) {
        super(props);
        this.state = {
            item: props.item,
            intents: [],
            entities: [],
        };
    }

    componentDidMount() {
        this.loadModels();
    }
    componentWillReceiveProps(nextProps: ScenarioEditProps) {
        this.setState({
            item: nextProps.item
        });
    }

    render() {
        const { isOpen, onSave, onCancel, isNew } = this.props;
        const model = this.model;
        return (
            <Modal isOpen={isOpen} className="scenario-edit">
                <ModalHeader>
                    {isNew ? i18n.Scenarios.Form.NewTitle : i18n.Scenarios.Form.EditTitle}
                </ModalHeader>
                <ModalBody>
                    {model && (
                        <Form>
                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.Name}</Label>
                                <br />
                                {!isNew && model.partitionKey}
                                {isNew && (
                                    <Input
                                        size={50}
                                        value={model.partitionKey}
                                        onChange={e => this.updateField("partitionKey", e)}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.CheckedOutBy}</Label>
                                <br />
                                {!isNew && model.checkedOutBy}
                                {isNew && (
                                    <Input
                                        size={50}
                                        value={model.checkedOutBy}
                                        onChange={e => this.updateField("checkedOutBy", e)}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.VirtualNode}
                                    <Input
                                        size={50}
                                        value={model.virtualNode}
                                        onChange={e => this.updateField("virtualNode", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.Category}
                                    <Input
                                        size={50}
                                        value={model.category}
                                        onChange={e => this.updateField("category", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>
                                            {i18n.Scenarios.Table.Market}
                                            <Typeahead
                                                multiple={false}
                                                labelKey="name"
                                                bsSize="sm"
                                                selected={(model.market || "")
                                                    .split(",")
                                                    .filter((s: string) => !!s)}
                                                allowNew={true}
                                                options={this.props.marketValues}
                                                selectHintOnEnter={true}
                                                onChange={e => this.updateField("market", null, e)}
                                                onBlur={(e: any) =>
                                                    this.updateField("market", null, [e.target.value])
                                                }
                                            />
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>
                                            {i18n.Scenarios.Table.Type}
                                            <Typeahead
                                                multiple={false}
                                                labelKey="name"
                                                bsSize="sm"
                                                selected={(model.type || "")
                                                    .split(",")
                                                    .filter((s: string) => !!s)}
                                                allowNew={true}
                                                options={this.props.typeValues}
                                                selectHintOnEnter={true}
                                                onChange={e => this.updateField("type", null, e)}
                                                onBlur={(e: any) =>
                                                    this.updateField("type", null, [e.target.value])
                                                }
                                            />
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.Intents}</Label>
                                <Typeahead
                                    multiple={true}
                                    labelKey="display"
                                    bsSize="sm"
                                    selected={(model.intents || "")
                                        .split(",")
                                        .filter((s: string) => !!s)}
                                    allowNew={true}
                                    options={this.state.intents}
                                    selectHintOnEnter={true}
                                    onChange={e => this.updateField("intents", null, e)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.Entities}</Label>
                                <Typeahead
                                    multiple={true}
                                    labelKey="display"
                                    bsSize="sm"
                                    selected={(model.entities || "")
                                        .split(",")
                                        .filter((s: string) => !!s)}
                                    allowNew={true}
                                    options={this.state.entities}
                                    selectHintOnEnter={true}
                                    onChange={e => this.updateField("entities", null, e)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.Keywords}
                                    <Input
                                        size={50}
                                        value={model.keywords}
                                        onChange={e => this.updateField("keywords", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.ScenarioDescription}
                                    <Input
                                        size={50}
                                        value={model.scenarioDescription}
                                        onChange={e => this.updateField("scenarioDescription", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.Languages}
                                    <Input
                                        size={50}
                                        value={model.languages}
                                        onChange={e => this.updateField("languages", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    {i18n.Scenarios.Table.UserTypes}
                                    <Input
                                        size={50}
                                        value={model.userTypes}
                                        onChange={e => this.updateField("userTypes", e)}
                                    />
                                </Label>
                            </FormGroup>
                            <FormGroup check={true}>
                                <Label check={true}>
                                    <Input
                                        type="checkbox"
                                        checked={this.state.item.disabled}
                                        onChange={e => this.updateField("disabled", null, e.target.checked)}
                                    />
                                    {i18n.Scenarios.Table.DisableScenario}
                                </Label>
                            </FormGroup>

                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.FallbackScenarioName}</Label>
                                <Typeahead
                                    labelKey="partitionKey"
                                    bsSize="sm"
                                    options={this.props.scenarioList.filter(s => !s.isCustomScenario)}
                                    // selected={(this.state.item.fallbackScenarioName || "")}
                                    selected={(model.fallbackScenarioName || "")
                                        .split(",")
                                        .filter((s: string) => !!s)}
                                    allowNew={false}
                                    selectHintOnEnter={true}
                                    onChange={e => this.updateField("fallbackScenarioName", null, e)}
                                    disabled={!this.state.item.disabled}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label>{i18n.Scenarios.Table.Channels}</Label>
                                <Channels
                                    model={model}
                                    onChange={(c, e) => this.updateChannels(c, e)}
                                    locked={false}
                                />
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => onSave(model)}
                        disabled={!this.isValid}
                    >
                        {i18n.Global.Edit.Confirm}
                    </Button>
                    <Button color="default" onClick={() => onCancel()}>
                        {i18n.Global.Edit.Cancel}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    private get model() {
        return this.state.item;
    }

    private get isValid(): boolean {
        return this.model && !!this.model.partitionKey;
    }

    private updateField(
        field: string,
        e: React.ChangeEvent<HTMLInputElement> | null,
        value?: any
    ) {
        const temp = {};
        switch (field) {
            case "intents":
            case "entities":
                temp[field] = value.map((x: any) =>
                    (this.getName(x, x.display) ? this.getName(x, x.display) : x)).join(",");
                break;
            case "type":
            case "market":
                temp[field] = value.map((x: any) => (x.name ? x.name : x)).join(",");
                break;
            case "disabled":
                temp[field] = value
                break;
            case "fallbackScenarioName":
                temp[field] = value.map((x: any) => (x.display ? x.display : x)).join(",");
                break;
            default:
                temp[field] = e ? e.target.value : value;
                break;
        }
        this.setState({
            item: {
                ...this.state.item,
                ...temp
            }
        });
    }
    private updateChannels(
        channel: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) {
        const { item } = this.state;

        let list: string[] = [];
        if (channel === "*") {
            if (e.target.checked) {
                list.push("*");
            }
        } else {
            list = ((item && item.channels) || "")
                .split(",")
                .filter((c: string) => !!c);
            if (e.target.checked) {
                list.push(channel);
            } else {
                list = list.filter(c => c !== channel);
            }
        }

        this.updateField("channels", null, list.join(","));
    }

    private getDisplayLuisItem(luisItem: any, suffix: string) {
        if (luisItem.prefixName) {
            return `${luisItem.prefixName}.${suffix}`;
        } else if (luisItem.modelId) {
            return `${luisItem.modelId}.${suffix}`;
        } else {
            return suffix;
        }
    }

    private getName(luisItem: any, display: string) {
        if (luisItem.prefixName || luisItem.modelId) {
            return luisItem.name;
        } else if (display !== undefined && display.includes(".")) {
            return display.substring(
                display.lastIndexOf(".") + 1,
                display.length);
        } else {
            return display;
        }
    }

    private async loadModels() {
        const intentsReply = await getAsync("/api/nlu/intents");
        const simpleEntitiesReply = await getAsync("/api/nlu/entities");
        const listEntitiesReply = await getAsync("/api/nlu/closedlists");
        const intentsPayload: any[] = await intentsReply.json();
        const simpleEntitiesPayload: any[] = await simpleEntitiesReply.json();
        const listEntitiesPayload: any[] = await listEntitiesReply.json();

        this.setState({
            intents: [
                { id: "*", name: "*", display: "*" },
                ...intentsPayload
                    .map(x => {
                        x.display = this.getDisplayLuisItem(x, x.name);
                        return x;
                    })
            ],
            entities: [
                { id: "*", name: "*", display: "*" },
                ...simpleEntitiesPayload
                    .concat(...listEntitiesPayload)
                    .map(x => {
                        if (x.subLists) {
                            return x.subLists.map((y: any) => ({
                                id: x.id,
                                name: `${x.name}:${y.canonicalForm}`,
                                display: this.getDisplayLuisItem(x, `${x.name}:${y.canonicalForm}`)
                            }));
                        } else {
                            return {
                                id: x.id,
                                name: x.name,
                                display: this.getDisplayLuisItem(x, x.name)
                            };
                        }
                    })
                    .reduce((s, v) => [...s, ...v], [])
            ]
        });
    }
}



// WEBPACK FOOTER //
// ./src/scenarios/scenario-edit.tsx